<template>
  <li class="nav-item group transition-all duration-100 hover:border-secondary" :class="css">
    <router-link :to="{ name: item.to }">
      <div class="flex items-center justify-center p-4">
        <img :src="require(`@/assets/img/${item.icon}`)" class="flex-shrink-0 mr-4" />
        <div class="w-full overflow-hidden">
          <h3 class="font-sans leading-tight md:text-xl uppercase mb-1">{{ item.title }}</h3>
          <p class="leading-tight text-neutral-800 text-sm md:text-base">{{ item.subtitle }}</p>
        </div>
        <div class="h-10 w-10 ml-2 bg-secondary-100 flex-shrink-0 flex items-center justify-center rounded-full group-hover:bg-secondary group-hover:text-white"><base-icon name="chevronright" size="lg" /></div>
      </div>
      <div v-if="textError" v-html="textError" class="text-white text-sm text-center bg-red-600 group-hover:bg-secondary p-2"></div>
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'MainNavItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    error: function () {
      return this.item.error
    },
    textError: function () {
      return this.error ? this.item.textError : ''
    },
    css: function () {
      return {
        'border-red-600': this.error,
        'border-secondary-50': !this.error,
        'border-4': this.error,
        'border-2': !this.error,
        'border-b-0': this.textError
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
